export default {
  label: {
    id: 'quantity_selector_label',
    defaultMessage: 'Quantity',
  },
}
